import React from 'react';
import '../styles/sections/services.scss';

const Services = (props) => {
    const data = props.data;
    function leadingZero(i){
        var j = i+1;
            j = "0"+j;
        return j.slice(-2);
    }
    return (
        <div className="services">
            <div className="innerBox lg">
                <h4 className="sectionSubHeading">{ data.subheading }</h4>
                <h3 className="sectionHeading" dangerouslySetInnerHTML={{ __html: data.title }} />
                <ul>
                    {data.list.map((d, i) =>
                        <li key={i}><strong>{leadingZero(i)}</strong><span>/</span>{d}</li>
                    )}                    
                </ul>
            </div>
        </div>
    )
}

export default Services;